export enum StatusEnum {
  COMPLETED = 'Completed',
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  OTHER = 'Other',
}

export enum LearningObjectTypeEnum {
  CURRICULUM = 'Curriculum',
  MATERIAL = 'Material',
  VIDEO = 'Video',
  EXTERNAL_TRAINING = 'External Training',
  ONLINE_COURSE = 'Online Course',
  EVENT = 'Event',
  SESSION = 'Session',
}
